module.exports = __webpack_public_path__ + "static/media/healthTabUnselected.c2d3553d.png";